import React, { useState, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  Button,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import axios from "axios";
import { Link } from "react-router-dom";

interface Assignment {
  id: number;
  title: string;
  status: "pending" | "completed";
}

interface Member {
  id: string;
  codename: string;
  assignments: Assignment[];
}

const QuestionnaireAssignments: React.FC = () => {
  const [members, setMembers] = useState<Member[]>([]);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    fetchMembers();
  }, []);

  const fetchMembers = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/members/assignments`
      );
      setMembers(response.data);
    } catch (error) {
      console.error("Error fetching participants and assignments:", error);
    }
  };

  const filteredMembers = members.filter((member) =>
    member.codename.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div>
      <TextField
        label="Search Participants"
        variant="outlined"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        style={{ marginBottom: "20px" }}
      />
      {filteredMembers.map((member) => (
        <Accordion key={member.id}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography>{member.codename}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Questionnaire</TableCell>
                    <TableCell>Status</TableCell>
                    <TableCell>Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {member.assignments.map((assignment) => (
                    <TableRow key={assignment.id}>
                      <TableCell>{assignment.title}</TableCell>
                      <TableCell>{assignment.status}</TableCell>
                      <TableCell>
                        <Button
                          component={Link}
                          to={`/members/${member.id}/questionnaires/${assignment.id}`}
                          variant="contained"
                          color="primary"
                          disabled={assignment.status === "completed"}
                        >
                          Fill Response
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </AccordionDetails>
        </Accordion>
      ))}
    </div>
  );
};

export default QuestionnaireAssignments;
